import { Spacing } from '@approvalmax/ui/src/components';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';

const SettingsPopupContentSkeleton = memo(() => {
    return (
        <>
            <Skeleton height={20} borderRadius={4} />

            <Spacing height={12} />

            <Skeleton height={20} width={120} borderRadius={4} />

            <Spacing height={12} />

            <Skeleton height={20} width={100} borderRadius={4} />
        </>
    );
});

export default SettingsPopupContentSkeleton;
